import Prismic from 'prismic-javascript'
// import config from '../config'

export const initApi = () => {
  return Prismic.getApi(window.CM_CONFIG.apis.prismic.endpoint)
}
